import React from 'react';
import { Component } from "react";
import {Navbar} from "react-bootstrap";
import {NavDropdown} from "react-bootstrap";
import { Person } from 'react-bootstrap-icons';
import { connect } from 'react-redux';
import {fetchToken} from '../store/Token/fetch'
var jwtDecode = require('jwt-decode');

class UserPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      pending: true,
      token: null
    };
  }
  componentDidMount() {
    this.props.fetchToken();
  }

    render() {
        if(this.props.pending){
          return (<div />);
        }
        if(this.props.token){
          var decoded = jwtDecode(this.props.token);
	        return (
        <Navbar.Collapse className="justify-content-end">
          <NavDropdown title={decoded.given_name}  id="basic-nav-dropdown" alignRight="true">
            <NavDropdown.Item href="#action/3.1">Sign Out</NavDropdown.Item>
          </NavDropdown>
        </Navbar.Collapse>);
        } else {
        return (
            <Navbar.Collapse className="justify-content-end">
          <NavDropdown title={<Person/>}  id="basic-nav-dropdown" alignRight="true">
            <NavDropdown.Item href="/user/login">Sign In</NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item href="/user/confirm">Confirm Email</NavDropdown.Item>
          </NavDropdown>
          </Navbar.Collapse>
            );
        }
    }
}
const mapStateToProps = (state) => {
  return {
      error: state.TokenReducer.error,
      pending: state.TokenReducer.pending,
      token: state.TokenReducer.result
  };
};

const mapDispatchToProps = {
    fetchToken
};

export default connect(mapStateToProps, mapDispatchToProps)(UserPanel);